import { Provider } from '@angular/core';
import { SERVICE_REPOSITORY } from '../../domain/tokens/service.token';
import { ServiceRepositoryAdapter } from '../adapters/service-repository.adapter';

export const SERVICE_PROVIDERS: Provider[] = [
  {
    provide: SERVICE_REPOSITORY,
    useClass: ServiceRepositoryAdapter
  },
];
